import { connect } from 'react-redux';

import { enterSpace } from '../../../app/actions/spaces/EnterSpaceAction';
import { AppState } from '../../../app/state/AppState';
import { SpaceItemForNonEntitySpace } from '../../../app/state/SpaceInfo';
import { MapDispatchToProps, MapStateToProps } from '../../../app/utils/ConnectUtils';
import { Sandbox, SandboxDispatchProps, SandboxStateProps } from './Sandbox';

const mapStateToProps: MapStateToProps<SandboxStateProps> = (state: AppState) => ({

});

const mapDispatchToProps: MapDispatchToProps<SandboxDispatchProps> = (dispatch) => ({
  enterSandbox: () => {
    dispatch(enterSpace({
      item: SpaceItemForNonEntitySpace,
      spaceType: 'sandbox',
      subspaceName: undefined
    }));
  }
});

export const ConnectedSandboxSpace = connect(mapStateToProps, mapDispatchToProps)(Sandbox);
